/**
 * @generated SignedSource<<aa500f20e3d7dec1fe15c7e9c6b89f0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTxnsNeedsReviewInputObject = {
  needsReview: boolean;
  txnIds: ReadonlyArray<string>;
};
export type needsReviewPage_SetTxnsNeedsReviewMutation$variables = {
  input: SetTxnsNeedsReviewInputObject;
};
export type needsReviewPage_SetTxnsNeedsReviewMutation$data = {
  readonly setTxnsNeedsReview: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type needsReviewPage_SetTxnsNeedsReviewMutation = {
  response: needsReviewPage_SetTxnsNeedsReviewMutation$data;
  variables: needsReviewPage_SetTxnsNeedsReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "needsReviewPage_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "needsReviewPage_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ded4db7cbaf93dd7bd1cbe5228fc054",
    "id": null,
    "metadata": {},
    "name": "needsReviewPage_SetTxnsNeedsReviewMutation",
    "operationKind": "mutation",
    "text": "mutation needsReviewPage_SetTxnsNeedsReviewMutation(\n  $input: SetTxnsNeedsReviewInputObject!\n) {\n  setTxnsNeedsReview(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57de55cb81eeb3de72a44318463aa1ba";

export default node;
